<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
  v-card
    //- Top bar
    v-card-title.px-4
      y-button(outlined prepend-icon="mdi-arrow-left" color="neutral400" icon-color="neutral700" icon-size="20" size="xs" unset-min-width button-class="px-1" @click="checkCloseDialog")
      div.text-xl.font-semibold.ml-4 Consultation notes
      v-spacer
      y-button(label="Save" size="sm" :loading="isLoading" @click="saveData")
    v-divider
    v-card-text.overflow-hidden.pa-0
      template(v-if="isSetting")
        v-skeleton-loader.pa-4(type="list-item-three-line@6")
        //- v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
      v-row.fill-height(v-else dense)
        v-col(cols="8")
          v-sheet
            .text-editor
              .button-container
                div.d-flex.align-center.justify-end.fill-height
                  y-button(:label="$t('attach_photo')" outlined color="neutral400" text-color="neutral700" prepend-icon="$yzi-upload-03" icon-color="neutral500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-2" @click="showAttachDialog = true")
                  y-button.ml-3(:label="uploadedFileCount ? $tc('files', uploadedFileCount) : 'Upload file'" outlined color="neutral400" text-color="neutral700" prepend-icon="$yzi-attachment-01" icon-color="neutral500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-2" @click="showAddEditFileDialog = true")
              froala(v-model="form" id="edit" :tag="'textarea'" :config="config" ref="editor")

        v-divider(vertical)
        v-col(cols="4")
          v-sheet.px-6.py-4
            //- visit note
            div.d-flex.align-center
              div.text-sm.font-semibold.neutral700--text {{ $t('visit_note') }}
              v-spacer
              y-button.ml-1(label="Edit" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" height="24" button-class="px-2" @click="showVisitNoteDialog = true")
            div.text-sm.neutral700--text.mt-2 {{ consultation.case || '-' }}
            //- vital signs
            vital-signs-section.mt-8(type="sheet")
              
  
  .dialogs
    attach-photo-dialog(v-if="showAttachDialog" :open.sync="showAttachDialog" @onUpload="onUploadPhoto")
    add-edit-file-dialog(v-if="showAddEditFileDialog" :open.sync="showAddEditFileDialog" :pid="leadPid" @onUpdateCount="updateFileCount")
    visit-note-dialog(v-if="showVisitNoteDialog" :open.sync="showVisitNoteDialog")
    alert-confirmation-dialog(v-if="showAlert" :open.sync="showAlert" @save="saveData" @discard="closeDialog")
      template(#title)
        div.text-md.font-semibold.neutral700--text Changes detected
      template(#content)
        div.text-md.neutral700--text Unsaved changes detected. Do you want to save or discard the changes?

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Vue from 'vue'
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import FroalaEditor from 'froala-editor/js/froala_editor.min'
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
FroalaEditor.DefineIcon('moreText',{SVG_KEY: 'more'})

import AttachPhotoDialog from '@/components/clinic/dialogs/AttachPhotoDialog.vue'
import AddEditFileDialog from '@/components/clinic/dialogs/AddEditFileDialog.vue'
import VitalSignsSection from '@/components/clinic/consultation/VitalSignsSection.vue'
import VisitNoteDialog from '@/components/clinic/consultation/VisitNoteDialog.vue'
import AlertConfirmationDialog from '@/components/clinic/consultation/AlertConfirmationDialog.vue'

export default {
  components: { AttachPhotoDialog, AddEditFileDialog, VitalSignsSection, VisitNoteDialog, AlertConfirmationDialog },
  props: {
    open: {
      type: Boolean,
    },
  },
  data () {
    return {
      isSetting: false,
      isLoading: false,
      showAttachDialog: false,
      showVisitNoteDialog: false,
      showAddEditFileDialog: false,
      showAlert: false,
      form: null,
      oriNotes: null,
      config: {
        events: {
          'image.beforeUpload' () {
            return false
          },
          // 'blur': () => {
          //   this.$emit('onSave')
          // }
        },
        key: process.env.VUE_APP_FROALA_API_KEY,
        attribution: false,
        scrollableContainer: '#edit',
        codeBeautifierOptions: {
          indent_inner_html: false,
          indent_size: 4
        },
        toolbarBottom: false,
        toolbarButtons: {
          'moreText': {
            buttons: ['bold', 'italic', 'underline', 'formatUL', 'undo', 'redo'],
            'buttonsVisible': 7
          }
        },
        quickInsertEnabled: false,
        imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
        imageEditButtons: ['imageCaption', 'imageRemove', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove'],
        imageResizeWithPercent: true,
        fontSize: ['8', '9', '10', '11', '12', '14', '18', '24', '30', '36', '48', '60', '72', '96'],
        paragraphFormat: {
          N: 'Normal',
          H1: 'Heading 1',
          H2: 'Heading 2',
          H3: 'Heading 3',
          H4: 'Heading 4',
        },
        toolbarSticky: false,
        height: '82dvh',
        charCounterCount: false,
        enter: FroalaEditor.ENTER_BR
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      consultation: 'treatment/getConsultation',
      leadPid: 'treatment/getLeadPid',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    uploadedFileCount () {
      return this.consultation.attachments.length
    },
    hasChanges () {
      if (JSON.stringify(this.form) !== JSON.stringify(this.oriNotes)) {
        return true
      }
      return false
    }
  },
  created () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.form = this.consultation.note
      this.oriNotes = this.consultation.note
    },
    onUploadPhoto (photos) {
      for (const i in photos) {
        const photo = photos[i]
        this.insertPhoto(photo)
      }
    },
    insertPhoto (photo) {
      const editor = this.$refs?.editor?.$el['data-froala.editor']
      if (editor) {
        let photoUrl = photo.file
        photoUrl = photoUrl.replace('https://cdn.yezza.io', 'https://img.yezza.io/full-fit-in')
        editor.image.insert(photoUrl, null, { 'name': photo.filename, 'id': photo.hid }, null, null)
      }
    },
    updateFileCount (items) {
      let files = items.map(m => m.id)
      this.$store.commit('treatment/updateConsultation', { attachments: files })
    },
    saveData () {
      this.isLoading = true
      this.$store.commit('treatment/updateConsultation', { note: this.form })
      this.$emit('save')
      this.closeDialog()
    },
    updateActivityLog (endpoint, payload, response, method, id, objectRef, activity) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: objectRef,
        activity: activity,
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
    checkCloseDialog () {
      if (this.hasChanges) {
        this.showAlert = true
      } else {
        this.closeDialog()
      }
    },
    closeDialog () {
      this.$emit('closed')
      this.showAlert = false
      this.showDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
.overflow-hidden {
  overflow: hidden !important;
}
::v-deep {
  .fr-box.fr-basic .fr-wrapper {
    border: none !important;
  }
  .fr-toolbar {
    border: none !important;
  }
  .fr-box .fr-counter {
    visibility: hidden !important;
  }
   p {
    margin-bottom: 0px !important;
  }
  ul, ol {
    padding-left: 0px;
  }
  li {
    font-family: $body-font-family;
    font-size: 16px !important;
    line-height: 24px !important;
    line-height: 24px !important;
  }
  .fr-box.fr-basic .fr-element.fr-view {
    font-family: $body-font-family;
    font-size: 16px !important;
    line-height: 24px !important;
    line-height: 24px !important;
    color: #333333;
  }
  .fr-second-toolbar {
    border: unset
  }
  .fr-box.fr-basic .fr-element.fr-view {
    font-size: 14px !important;
  }
  .fr-dropdown-menu {
    left: unset !important;
    bottom: unset !important;
    margin-left: unset !important;
  }
}
.text-editor {
  position: relative;
}
.button-container {
  position: absolute;
  height: 48px;
  left: 0;
  top: 0;
  margin-left: 330px;
  width: -webkit-fill-available;
  padding-right: 12px;
  z-index: 1;
}
</style>

<i18n>
{
  "en": {
    "files" : "1 file in this case notes | {n} files in this case notes"
  }
}
</i18n>